// frontend/services/transactions.js
import api from './api';

export const transactionService = {
    getTransactions: (params) => api.get('/transactions', { params }).then(res => res.data),
    
    getTransaction: (id) => api.get(`/transactions/${id}`).then(res => res.data),
    
    createTransaction: (data) => api.post('/transactions', data).then(res => res.data),
    
    createPOSSale: (data) => api.post('/transactions/pos-sale', data).then(res => res.data),
    
    createInvoice: (data) => api.post('/transactions/invoice', data).then(res => res.data),
    
    updateTransaction: (id, data) => api.put(`/transactions/${id}`, data).then(res => res.data),
    
    recordPayment: (id, data) => api.post(`/transactions/${id}/pay`, data).then(res => res.data),
    
    voidTransaction: (id, reason) => api.post(`/transactions/${id}/void`, { reason }).then(res => res.data),
    
    sendReminder: (id) => api.post(`/transactions/${id}/reminder`).then(res => res.data),
    
    downloadInvoice: (id) => api.get(`/transactions/${id}/download`, { responseType: 'blob' }).then(res => res.data),
    
    getAgingReport: () => api.get('/transactions/aging').then(res => res.data),
    
    getZReport: (date) => api.get('/transactions/z-report', { params: { date } }).then(res => res.data),
    
    getDailySales: (date) => api.get('/transactions/daily-sales', { params: { date } }).then(res => res.data)
};